import { SpaceProps } from "styled-system";

import { Wrapper, Label, Hint, Check, Box } from "./toggle-switch-style";

interface Props {
    label: string;
    checked?: boolean;
    onChange: (checked: boolean) => void;
    hint?: string;
    spacing?: SpaceProps;
    isEnabled?: boolean;
    flat?: boolean;
}

const ToggleSwitch = ({ label, onChange, checked, hint, spacing, isEnabled,
    flat = true // set to true for backwards compatibility reasons
}: Props) => {
    return (
        <Wrapper isEnabled={isEnabled} {...spacing} data-test={"bld-tgl-sw"}>
            <Label>
                <Box {...{ checked, flat, isEnabled }}>
                    {checked && <Check />}
                </Box>
                {label}
                <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} />
            </Label>
            {hint !== undefined && <Hint>{hint}</Hint>}
        </Wrapper>
    );
};

export default ToggleSwitch;
